/**
 * @fileOverview This file contains the implementation of the MovementModal component for Inventory module
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import '../../scss/Components/Inventory/_movementmodal.scss';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Grid,
  Box,
  IconButton,
} from '@mui/material';
import MovementForm from './MovementForm';
import CloseIcon from '@mui/icons-material/Close';
//#endregion

const MovementModal = ({
  itemId,
  showMovementModal,
  setShowMovementModal,
  image,
  currency_symbol,
  cost,
  code,
  warehouseId,
  warehouse,
  locationId,
  location,
  stock,
  item_name,
  model,
  manufacturer_name,
  refreshItems,
}) => {
  return (
    <Dialog
      open={showMovementModal}
      onClose={() => setShowMovementModal(false)}
      fullWidth={true}
      maxWidth={'lg'}
    >
      <DialogTitle>
        <Typography className='inventory-movmodal-title'>
          Nuevo movimiento de:{'  '}
          <span className='movement-movmodal-item-highlight'>{item_name}</span>
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={() => setShowMovementModal(false)}
        sx={{
          position: 'absolute',
          right: 20,
          top: 20,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ display: 'flex', width: '100%' }} dividers>
        <Grid container>
          <Grid item xs={4} display='flex' flexDirection='column'>
            <Box
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              height={300}
            >
              <img
                src={image}
                alt={item_name}
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            </Box>
            <Box display={'flex'} flexDirection={'column'} p={2} gap={1}>
              <Box
                width={'100%'}
                display={'flex'}
                justifyContent={'space-between'}
                gap={10}
              >
                <Box
                  width={'50%'}
                  display={'flex'}
                  justifyContent={'space-between'}
                >
                  <Typography className='inventory-movmodal-item-label'>
                    Costo:
                  </Typography>
                  <Typography className='inventory-movmodal-item-data'>
                    {currency_symbol + cost}
                  </Typography>
                </Box>
                <Box
                  width={'50%'}
                  display={'flex'}
                  justifyContent={'space-between'}
                >
                  <Typography className='inventory-movmodal-item-label'>
                    Código:
                  </Typography>
                  <Typography
                    className='inventory-movmodal-item-data'
                    id='item-code'
                  >
                    {code}
                  </Typography>
                </Box>
              </Box>

              <Box
                width={'100%'}
                display={'flex'}
                justifyContent={'space-between'}
                gap={10}
              >
                <Box
                  width={'50%'}
                  display={'flex'}
                  justifyContent={'space-between'}
                >
                  <Typography className='inventory-movmodal-item-label'>
                    Ubicación:
                  </Typography>
                  <Typography className='inventory-movmodal-item-data'>
                    {location}
                  </Typography>
                </Box>
                <Box
                  width={'50%'}
                  display={'flex'}
                  justifyContent={'space-between'}
                >
                  <Typography className='inventory-movmodal-item-label'>
                    En Stock:
                  </Typography>
                  <Typography className='inventory-movmodal-item-data'>
                    {stock}
                  </Typography>
                </Box>
              </Box>

              <Box
                width={'100%'}
                display={'flex'}
                justifyContent={'space-between'}
                gap={10}
              >
                <Typography className='inventory-movmodal-item-label'>
                  Almacén:
                </Typography>
                <Typography className='inventory-movmodal-item-data'>
                  {warehouse}
                </Typography>
              </Box>

              <Box
                width={'100%'}
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'space-between'}
                gap={1}
              >
                <Box
                  width={'100%'}
                  display={'flex'}
                  gap={3}
                  justifyContent={'space-between'}
                >
                  <Typography className='inventory-movmodal-item-label'>
                    Nombre:
                  </Typography>
                  <Typography className='inventory-movmodal-item-data'>
                    {item_name}
                  </Typography>
                </Box>
                <Box
                  width={'100%'}
                  display={'flex'}
                  justifyContent={'space-between'}
                >
                  <Typography className='inventory-movmodal-item-label'>
                    Modelo:
                  </Typography>
                  <Typography className='inventory-movmodal-item-data'>
                    {model}
                  </Typography>
                </Box>
                <Box
                  width={'100%'}
                  display={'flex'}
                  justifyContent={'space-between'}
                >
                  <Typography className='inventory-movmodal-item-label'>
                    Fabricante:
                  </Typography>
                  <Typography className='inventory-movmodal-item-data'>
                    {manufacturer_name}
                  </Typography>
                </Box>
                <Box
                  width={'100%'}
                  display={'flex'}
                  justifyContent={'space-between'}
                >
                  <Typography className='inventory-movmodal-item-label'>
                    Última fecha de entrada:
                  </Typography>
                  <Typography className='inventory-movmodal-item-data'>
                    23/05/2024
                  </Typography>
                </Box>
                <Box
                  width={'100%'}
                  display={'flex'}
                  justifyContent={'space-between'}
                >
                  <Typography className='inventory-movmodal-item-label'>
                    Última fecha de salida:
                  </Typography>
                  <Typography className='inventory-movmodal-item-data'>
                    20/05/2024
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={8} mb={2}>
            <MovementForm
              refreshItems={refreshItems}
              itemId={itemId}
              itemName={item_name}
              onHide={setShowMovementModal}
              warehouseId={warehouseId}
              warehouseName={warehouse}
              locationId={locationId}
              locationName={location}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default MovementModal;
